window.changeDocumentNumber = function(input, url, callback = null) {
    var $form = $(input).parents('form');

    if (!$(input).val()) {
        $form.find('[name="order_product_ids[]"]').parents('.form-group').hide();
        $form.find('[name="product_names[]"]').parents('.form-group').show();

        $form.find('[name="order_product_ids[]"]').parents('.c-form__item').parent().hide();
        $form.find('[name="product_names[]"]').parents('.c-form__item').parent().show();
    } else {
        Form.fetchDependentOptions(input, 'order_product_ids[]', url, {
            callback: function() {
                $form.find('[name="order_product_ids[]"]').parents('.form-group').show();
                $form.find('[name="product_names[]"]').parents('.form-group').hide();

                $form.find('[name="order_product_ids[]"]').parents('.c-form__item').parent().show();
                $form.find('[name="product_names[]"]').parents('.c-form__item').parent().hide();

                if (callback !== null) {
                    callback(input);
                }
            }
        });
    }
}

window.changeDocumentNumberCallback = function(input) {
    var $form = $(input).parents('form');
    window.orderProductCount = $form.find('[name="order_product_ids[]"]:first').find('option').length;
    $form.find('[name="order_product_ids[]"]').prepend('<option value="" selected>' + window.wholeOrderTranslated + '</option>');
    $form.find('[name="order_product_ids[]"]').trigger('change');

    removeDuplicatedProductBlocks();
}

window.removeDuplicatedProductBlocks = function() {
    $('.js-product-block').each(function (index, el) {
        const attr = $(el).data('first-block');

        if (attr === null) {
            $(el).remove();
        }
    });
}

window.validateClaimForm = function() {
    $('.js-form-account-claim').validate({
        rules: {
            customer_email: {
                email: true
            },
            customer_post_code: {
                number: true
            },
            "product_names[]": {
                required: true
            },
            "order_product_ids[]": {
                required: true
            },
            "defect_descriptions[]": {
                required: true
            },
        },
        errorPlacement: function(error, element) {
            if (element.attr("type") && element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            const $submitBtn = $(form).find('.c-btn[type="submit"]');
            const $captcha = $(form).find('.g-recaptcha');

            if ($captcha.length == 0) {
                $submitBtn
                    .prop('disabled', true)
                    .addClass('is-loading');

                form.submit();
                return true;
            }

            const $captchaWrapper = $captcha.parent('.captcha-wrapper');
            let captchaIndex = -1;

            $('.g-recaptcha').each(function (k, v) {
                if ($(this)[0] == $captcha[0]) {
                    captchaIndex = k;
                }
            });

            $captchaWrapper.find('label').remove();

            if (captchaIndex !== -1 && grecaptcha.getResponse(captchaIndex)) {
                $submitBtn
                    .prop('disabled', true)
                    .addClass('is-loading');

                form.submit();
            } else {
                $captchaWrapper.append(
                    '<label class="error">' + $captchaWrapper.data('error') + '</label>'
                );
            }
        }
    });
}

window.orderProductChange = function(e) {
    const $this = $(this);
    const $addProductLink = $('.js-add-product-block');

    if ($this.val() === "" || $this.val() === null) {
        $this.parents('.js-product-block').find('[name="product_quantities[]"]').attr('type', 'hidden');
        $this.parents('.js-product-block').find('[name="product_quantities[]"]').val("1");
        $this.parents('.js-product-block').find('[name="product_quantities[]"]').siblings('label').hide();
        $addProductLink.hide();

        $('.js-product-block').data('first-block', null);
        $this.parents('.js-product-block').data('first-block', '1');
        removeDuplicatedProductBlocks();
    } else {
        // const quantity = $this.find('option:selected').data('quantity');

        $this.parents('.js-product-block').find('[name="product_quantities[]"]').attr('type', 'input');
        $this.parents('.js-product-block').find('[name="product_quantities[]"]').val('1');
        $this.parents('.js-product-block').find('[name="product_quantities[]"]').siblings('label').show();

        if ($('.js-product-block').length < window.orderProductCount) {
            $addProductLink.show();
        }
    }
}

$(function() {
    $('[name="order_product_ids[]"]').change(orderProductChange);

    // duplicate product blocks
    $('.js-add-product-block').click(function (e) {
        e.preventDefault();

        const $lastBlock = $('.js-product-block:last');

        const $duplicatedBlock = $lastBlock.clone();
        $duplicatedBlock.find('option').each(function (index, el) {
            if ($(el).val() == '') {
                $(el).remove();
            }
        });

        // clear existing input values
        $duplicatedBlock.find('input,textarea').each(function (index, el) {
            $(el).val('');
            $(el).attr('id', $(el).attr('id') + '_' + $('.js-product-block').length);
        })

        $duplicatedBlock.find('.is-remove').css('display', 'block');
        $duplicatedBlock.find('.is-remove').click(function () {
            $duplicatedBlock.remove();
        });

        $('.js-product-block:last').after($duplicatedBlock);
        $('.js-product-block:last').data('first-block', null);

        $('.js-form-account-claim').find("[name^=product_names]").each(function(){
            $(this).rules("add", {
                required: true,
            });
        });

        $('.js-form-account-claim').removeData('validator');
        validateClaimForm();

        if (window.orderProductCount) {
            $('.js-product-block:last').find('[name="order_product_ids[]"]').change(orderProductChange);

            if ($('.js-product-block').length < window.orderProductCount) {
                $('.js-add-product-block').show();
            } else {
                $('.js-add-product-block').hide();
            }
        }
    })

    $('[name="order_product_id"]').bind('change', function() {
        var $this = $(this),
            quantity = $this.find('option:selected').attr('data-quantity'),
            $quantityInput = $('#product-quantity');

        $('[name="product_name"]').val($this.find('option:selected').text());

        $quantityInput.attr('max', quantity);
    });

    $.validator.prototype.elements= function() {
        var validator = this,
            rulesCache = {};

        // select all valid inputs inside the form (no submit or reset buttons)
        // workaround $Query([]).add until http://dev.jquery.com/ticket/2114 is solved
        return $([]).add(this.currentForm.elements)
        .filter(":input")
        .not(":submit, :reset, :image, [disabled]")
        .not( this.settings.ignore )
        .filter(function() {
            !this.name && validator.settings.debug && window.console && console.error( "%o has no name assigned", this);

            // select only the first element for each name (EXCEPT elements that end in []), and only those with rules specified
            if ( (!this.name.match(/\[\]/gi) && this.name in rulesCache) || !validator.objectLength($(this).rules()) )
                return false;

            rulesCache[this.name] = true;
            return true;
        });
        };


        $.validator.prototype.idOrName = function(element) {

        // Special edit to get fields that end with [], since there are several [] we want to disambiguate them
        // Make an id on the fly if the element doesnt have one
        if(element.name.match(/\[\]/gi)) {
            if(element.id){
                return element.id;
            } else {
                var unique_id = new Date().getTime();

                element.id = new Date().getTime();

                return element.id;
            }
        }

        return this.groups[element.name] || (this.checkable(element) ? element.name : element.id || element.name);
        };

    validateClaimForm();
});
